import { useEffect, useState } from 'react'

export default function DevGrid() {
  /// #if _DEBUG
  const [show, setShow] = useState(import.meta.env.VITE_DEV_GRID === 'true')

  useEffect(() => {
    const onKeydown = (e: KeyboardEvent) => {
      if ((e.key === 'K' || e.key === 'k') && e.metaKey && e.shiftKey) {
        setShow((prev) => !prev)
      }
    }

    window.addEventListener('keydown', onKeydown)

    return () => {
      window.removeEventListener('keydown', onKeydown)
    }
  }, [])

  return (
    <div className={`fixed inset-0 z-9999999 container pointer-events-none ${show ? 'opacity-5' : 'opacity-0'}`}>
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i} className='w-full min-h-dvh md:h-screen bg-coral' />
      ))}
    </div>
  )
  /// #endif

  return <></>
}
